if (!customElements.get('hot-spot')) {
  customElements.define('hot-spot', class extends HTMLElement {
    constructor() {
      super()
      this.hotspotInstance = null
      this.configureHotspot()
    }

    configureHotspot() {
      const contentEl = document.getElementById(`${this.id}-content`)

      if (contentEl != null) {
        const content = contentEl.content

        this.hotspotInstance = tippy(this, {
          content,
          placement: 'bottom',
          allowHTML: true,
          maxWidth: 350,
          interactive: true,
          theme: 'woolroom',
          trigger: 'click',
        })

        const closeButton = this.hotspotInstance.popper.querySelector('.hotspot__close')

        if (closeButton) {
          closeButton.addEventListener('click', () => {
            this.hotspotInstance.hide()
          })
        }
      }
    }
  })
}
